import i18next from "../locales/i18n";

const UIKIT_VERSION = "3.20.8";
const UIKIT_LTR = `https://cdn.jsdelivr.net/npm/uikit@${UIKIT_VERSION}/dist/css/uikit.min.css`;
const UIKIT_RTL = `https://cdn.jsdelivr.net/npm/uikit@${UIKIT_VERSION}/dist/css/uikit-rtl.min.css`;

const BRAND_OVERRIDE_CSS = `
:root {
  --main-color: #d9a43c !important;
  --uk-primary: #d9a43c !important;
}
.uk-text-primary,
.uk-link.uk-link-toggle:hover .uk-link-heading,
.uk-link-toggle:hover .uk-link-heading,
.uk-link-heading:hover {
  color: #d9a43c !important;
}
.uk-button-primary,
.uk-button-primary:focus,
.uk-button-primary:hover {
  background-color: #d9a43c !important;
}
.uk-label-primary,
.uk-badge,
.uk-background-primary {
  background-color: #d9a43c !important;
}
.uk-checkbox:checked,
.uk-checkbox:indeterminate,
.uk-radio:checked {
  background-color: #d9a43c !important;
  border-color: #d9a43c !important;
}
.uk-range::-webkit-slider-thumb {
  background: #d9a43c !important;
}
`;

function ensureBrandOverrides() {
  let style = document.getElementById("brand-theme-overrides");
  if (!style) {
    style = document.createElement("style");
    style.id = "brand-theme-overrides";
    document.head.appendChild(style);
  }
  style.textContent = BRAND_OVERRIDE_CSS;
  document.head.appendChild(style);
}

export function applyDocumentDirection(lang) {
  const language =
    lang || i18next.language || localStorage.getItem("lang") || "ar";
  const dir = language === "en" ? "ltr" : "rtl";

  document.body.dir = dir;
  document.documentElement.lang = language;
  document.documentElement.dir = dir;

  let link = document.getElementById("uikit-theme");
  if (!link) {
    link = document.createElement("link");
    link.id = "uikit-theme";
    link.rel = "stylesheet";
    document.head.insertBefore(link, document.head.firstChild);
  }

  const nextHref = dir === "rtl" ? UIKIT_RTL : UIKIT_LTR;
  if (link.getAttribute("href") !== nextHref) {
    link.setAttribute("href", nextHref);
    link.onload = ensureBrandOverrides;
  }

  ensureBrandOverrides();
}
